import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const SkipToMain = () => {
  const location = useLocation();

  const href = `${location.pathname}#main-content`;

  const [isKeyboardUser, setIsKeyboardUser] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        setIsKeyboardUser(true);
      }
    };

    const handleMouseDown = () => {
      setIsKeyboardUser(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('mousedown', handleMouseDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  useEffect(() => {
    if (location.hash === '#main-content') {
      const main = document.getElementById('main-content');
      if (main) {
        main.focus();
      }
    }
  }, [location]);

  return (
    <a
      href={href}
      id="skip-to-content"
      aria-label="Skip to main content"
      className={`sr-only ${
        isKeyboardUser
          ? 'focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded focus:shadow-md'
          : ''
      }`}
    >
      Skip to main content
    </a>
  );
};
